import { render } from "./GeneralKnowledgeTop.vue?vue&type=template&id=0e098904"
import script from "./GeneralKnowledgeTop.vue?vue&type=script&lang=js"
export * from "./GeneralKnowledgeTop.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__